import { defineRecipe } from '@plurall/elo-v3';

export const navAccordionItemRecipe = defineRecipe({
  className: 'local-navigation__accordion-item',
  base: {
    border: 'none',
    borderBottom: '0',
    background: 'transparent',
    width: '100%',
    minWidth: 0,
  },
});

export const navAccordionTriggerRecipe = defineRecipe({
  className: 'local-navigation__accordion-trigger',
  base: {
    '--item-size': '40px',
    '--item-icon-size': '24px',
    '--item-label-color': 'var(--sidebar-text-color)',
    '--item-icon-color': 'var(--sidebar-icon-color)',

    display: 'grid !important',
    gap: 'space.12',
    gridTemplateColumns: 'var(--item-icon-size) minmax(0, 1fr) var(--item-icon-size)',
    inlineSize: '100%',
    minBlockSize: 'var(--item-size)',
    padding: 'padding.xsmall',
    borderRadius: 'border.radius.xsmall',
    textDecoration: 'none',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color .15s ease-in-out, color .15s ease-in-out',
    '&:hover, &:focus-visible': {
      background: 'alpha.teal.16',
      color: 'foreground.brand',
    },
    '&:focus-visible': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'action.focus.ring.primary',
      outlineOffset: '2px',
    },
    '[data-open="true"] &, [data-open="false"]:hover &': {
      sm: {
        transition:
          'background-color var(--sidebar-transition-duration) ease-in-out, ' +
          'color var(--sidebar-transition-duration) ease-in-out, ' +
          'inline-size var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1), ' +
          'grid-template-columns var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1), ' +
          'gap var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1), ' +
          'border-radius var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1)',
      },
    },
    '[data-open="false"]:not(:hover) &': {
      sm: {
        blockSize: 'var(--item-size)',
        inlineSize: 'var(--item-size)',
        borderRadius: 'calc(var(--item-size) / 2)',
        overflow: 'clip',
        gap: '0',
        gridTemplateColumns: 'var(--item-icon-size) 0 0',
      },
    },
    sm: {
      transition:
        'background-color .15s ease-in-out, color .15s ease-in-out, ' +
        'inline-size var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1), ' +
        'grid-template-columns var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1), ' +
        'gap var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1), ' +
        'border-radius var(--sidebar-transition-duration) cubic-bezier(0.77, 0, 0.18, 1)',
    },
  },
  variants: {
    isActive: {
      true: {
        background: 'alpha.teal.16',
        color: 'foreground.brand',
      },
      false: {},
    },
  },
  defaultVariants: {
    isActive: false,
  },
});

export const navAccordionContentRecipe = defineRecipe({
  className: 'local-navigation__accordion-panel',
  base: {
    overflow: 'clip',
    overflowClipMargin: '4px',
    transition: 'width .15s ease-in-out, max-block-size .15s ease-in-out',
    '[data-open="false"]:not(:hover) &': {
      maxBlockSize: '0',
      width: '0 !important',
    },
  },
});

export const navAccordionIndicatorRecipe = defineRecipe({
  className: 'local-navigation__accordion-indicator',
  base: {},
});

export const navSublistRecipe = defineRecipe({
  className: 'local-navigation__sublist',
  base: {},
});

export const navSubitemRecipe = defineRecipe({
  className: 'local-navigation__subitem',
  base: {},
});
